import { Api } from 'utils';

class ReferralService {
  static admin = {
    get: async (params?: any) => Api.createResponse('admin/referral/withdrawals/get', params),
    process: async (params?: any) =>
      Api.createResponse('admin/referral/withdrawals/process', params),
  };

  // Endpoints app/referral/* -- creados originalmente para Mobile, pero son
  // genéricos del backend (JwtAuthGuard, sin restricción por plataforma) así
  // que se reusan tal cual desde la Web App.
  static client = {
    getMe: async (params?: any) => Api.createResponse('app/referral/me', params),
    getMovements: async (params?: any) => Api.createResponse('app/referral/movements', params),
    getWithdrawals: async (params?: any) =>
      Api.createResponse('app/referral/withdrawals/get', params),
    requestWithdrawal: async (params?: any) =>
      Api.createResponse('app/referral/withdrawals/create', params),
  };
}

export default ReferralService;
